(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eb-currex-gallery-filter"] && !Shopify.designMode) return;
  try {
    (()=>{const root=document.querySelector('[data-currex-gallery-config]');if(!root)return;const cfg=JSON.parse(root.textContent),gallery=document.querySelector('[data-product-gallery]'),thumbs=[...gallery.querySelectorAll('[data-product-thumb]')],slides=[...gallery.querySelectorAll('[data-product-slide]')];let visible=cfg.initial;const status=document.querySelector('[data-currex-status]');function apply(ids){visible=ids;thumbs.forEach(t=>t.hidden=!ids.includes(Number(t.dataset.productThumb)));if(status)status.textContent='表示 '+ids.length+'枚 / 保存画像48枚';}apply(visible);let start=null;const stage=gallery.querySelector('.eb-product__main-media');stage.addEventListener('dragstart',e=>e.preventDefault());stage.addEventListener('pointerdown',e=>{start=e.clientX;});stage.addEventListener('pointerup',e=>{if(start===null)return;const dx=e.clientX-start;start=null;if(Math.abs(dx)<40)return;const active=Number(slides.find(s=>s.classList.contains('is-active'))?.dataset.productSlide||0);const pos=visible.indexOf(active);const next=visible[(pos+(dx<0?1:-1)+visible.length)%visible.length];thumbs.find(t=>Number(t.dataset.productThumb)===next)?.click();});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-facepump-faq"] && !Shopify.designMode) return;
  try {
    (() => {
  const showFacepump = () => {
    if (window.location.hash !== '#page_facepump') return;
    const target = document.getElementById('page_facepump');
    const radio = target?.closest('.cp_tabpanels')?.querySelector('input[type="radio"]');
    if (!target || !radio) return;
    radio.checked = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  window.addEventListener('hashchange', showFacepump);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showFacepump, { once: true });
  else showFacepump();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-fitsole-faq"] && !Shopify.designMode) return;
  try {
    (() => {
  const showFitsole = () => {
    if (window.location.hash !== '#page_fitsole') return;
    const target = document.getElementById('page_fitsole');
    const radio = target?.closest('.cp_tabpanels')?.querySelector('input[type="radio"]');
    if (!target || !radio) return;
    radio.checked = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  window.addEventListener('hashchange', showFitsole);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showFitsole, { once: true });
  else showFitsole();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-installments"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeInstallments() {
    document.querySelectorAll('[data-installments]').forEach(panel => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      const data = JSON.parse(panel.querySelector('[data-installment-data]').textContent);
      const format = (amount, count) => data.monthly.replace('{amount}', Math.round(amount).toLocaleString('ja-JP')).replace('{count}', count);
      const displayEstimate = (target, text) => {
        const parts = text.match(/^(.*?)([（(].*[）)])$/);
        target.textContent = parts ? parts[1].trim() : text;
        if (parts) {
          const term = document.createElement('span');
          term.className = 'eb-installments__term';
          term.textContent = parts[2];
          target.append(term);
        }
      };
      const update = id => {
        const variant = data.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        const price = variant.price / 100;
        const count = price >= 12000 ? 12 : price >= 6000 ? 6 : price >= 3000 ? 3 : 0;
        displayEstimate(panel.querySelector('[data-paidy-estimate]'), count ? format(price / count, count) : data.paidyMinimum);
        displayEstimate(panel.querySelector('[data-sbps-estimate]'), price >= 10000 ? format(price * 1.15 / 24, 24) : data.sbpsMinimum);
      };
      update(panel.dataset.initialVariant);
      document.addEventListener('change', event => { if (event.target.matches('[data-product-variant]')) update(event.target.value); });
      window.addEventListener('pageshow', () => update(document.querySelector('[data-product-variant]')?.value || panel.dataset.initialVariant));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeInstallments, {once:true});
  else initializeInstallments();
  document.addEventListener('shopify:section:load', initializeInstallments);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-liftone-voices"] && !Shopify.designMode) return;
  try {
    class EbLiftoneReviews extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.abort = new AbortController();
    this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.data = JSON.parse(this.querySelector('[data-reviews]').textContent);
    this.reviews = [...this.data.reviews].sort((a,b) => b.date.localeCompare(a.date) || a.id-b.id);
    this.limit = 12;
    this.list = this.dataset.mode === 'list';
    this.listen(this.querySelector('[data-star]'), 'change', () => this.filter());
    this.listen(this.querySelector('[data-model]'), 'change', () => this.filter());
    this.listen(this.querySelector('[data-more]'), 'click', () => { this.limit += 12; this.renderList(true); });
    this.listen(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
    this.listen(this.querySelector('[data-next]'), 'click', () => this.move(1));
    this.listen(this.querySelector('[data-track]'), 'keydown', event => {
      if (event.target !== event.currentTarget) return;
      if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home'?0:this.track.scrollWidth,behavior:this.behavior});
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    if (this.list) this.filter(); else this.renderCarousel();
  }
  disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  listen(node,type,callback) { node?.addEventListener(type,callback,{signal:this.abort.signal}); }
  get behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  text(tag,value,className) { const node=document.createElement(tag); node.textContent=value; if(className) node.className=className; return node; }
  link(label,url) { const a=this.text('a',label); a.href=url; return a; }
  card(review) {
    const card=document.createElement('article'); card.className='eb-voice-card'; card.id=`review-${review.id}`;
    const meta=this.text('div','','eb-voice-meta');
    const time=this.text('time',review.date.replaceAll('-','/')); time.dateTime=review.date;
    meta.append(this.text('span',this.labels.buyer),time);
    const stars=this.text('p','★'.repeat(review.rating)+'☆'.repeat(5-review.rating),'eb-voice-stars'); stars.setAttribute('aria-label',`${review.rating}/5`);
    card.append(meta,stars,this.text('p',`${review.model} / ${review.color}`,'eb-voice-model'));
    if(review.title) card.append(this.text('h3',review.title));
    card.append(this.text('p',review.body,'eb-voice-body'));
    if(!this.list) {
      const foot=this.text('div','','eb-voice-foot');
      foot.append(this.link(this.labels.full,`${this.dataset.listUrl}#review-${review.id}`));
      card.append(foot);
    }
    return card;
  }
  filter() {
    this.limit=12;
    const star=this.querySelector('[data-star]').value,model=this.querySelector('[data-model]').value;
    this.filtered=this.reviews.filter(r=>(!star||r.rating===Number(star))&&(!model||r.model===model));
    this.renderList();
  }
  renderList(focusNew=false) {
    const grid=this.querySelector('[data-grid]'), previous=grid.children.length;
    const hash=location.hash.match(/^#review-(\d+)$/);
    let target;
    if(!focusNew&&hash) {
      target=this.filtered.findIndex(r=>r.id===Number(hash[1]));
      if(target>=0) this.limit=Math.max(this.limit, Math.ceil((target+1)/12)*12);
    }
    grid.replaceChildren(...this.filtered.slice(0,this.limit).map(r=>this.card(r)));
    this.querySelector('[data-count]').textContent=`${this.labels.published} ${this.reviews.length}${this.labels.unit} / ${this.labels.matching} ${this.filtered.length}${this.labels.unit}`;
    this.querySelector('[data-empty]').hidden=this.filtered.length>0;
    this.querySelector('[data-more]').hidden=this.limit>=this.filtered.length;
    if(focusNew&&grid.children[previous]) { grid.children[previous].tabIndex=-1; grid.children[previous].focus(); }
    if(target>=0) requestAnimationFrame(()=>grid.children[target]?.scrollIntoView({block:'start'}));
  }
  renderCarousel() {
    const selected=[...this.querySelectorAll('[data-review-id]')].map(node=>Number(node.dataset.reviewId));
    const unique=[...new Set(selected)].slice(0,Number(this.dataset.count)||6);
    const reviews=unique.map(id=>this.reviews.find(r=>r.id===id)).filter(Boolean);
    this.track=this.querySelector('[data-track]'); this.track.replaceChildren(...reviews.map(r=>this.card(r)));
    const update=()=>{
      this.querySelector('[data-prev]').disabled=this.track.scrollLeft<2;
      this.querySelector('[data-next]').disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
    };
    this.listen(this.track,'scroll',update); this.listen(window,'resize',update); requestAnimationFrame(update);
    this.querySelector('[data-status]').textContent=`${reviews.length}${this.labels.unit}`;
  }
  move(direction) { if(!this.track?.firstElementChild)return; this.track.scrollBy({left:direction*(this.track.firstElementChild.getBoundingClientRect().width+24),behavior:this.behavior}); }
}
if(!customElements.get('eb-liftone-reviews'))customElements.define('eb-liftone-reviews',EbLiftoneReviews);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-payment-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const initialize = () => {
      document.querySelectorAll('.eb-payment-guide__disclosure').forEach((disclosure) => {
        if (disclosure.dataset.initialized) return;
        disclosure.dataset.initialized = 'true';
        const summary = disclosure.querySelector('summary');
        const sync = () => {
          disclosure.open = !mobile.matches;
          summary.tabIndex = mobile.matches ? 0 : -1;
        };
        summary.addEventListener('click', (event) => {
          if (!mobile.matches) event.preventDefault();
        });
        mobile.addEventListener('change', sync);
        sync();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-purenano-faq"] && !Shopify.designMode) return;
  try {
    (() => {
  const showPurenano = () => {
    if (window.location.hash !== '#page_purenano') return;
    const target = document.getElementById('page_purenano');
    const radio = target?.closest('.cp_tabpanels')?.querySelector('input[type="radio"]');
    if (!target || !radio) return;
    radio.checked = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  window.addEventListener('hashchange', showPurenano);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showPurenano, { once: true });
  else showPurenano();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-rocklean-faq"] && !Shopify.designMode) return;
  try {
    (() => {
  const showRocklean = () => {
    if (window.location.hash !== '#page_rocklean') return;
    const target = document.getElementById('page_rocklean');
    const radio = target?.closest('.cp_tabpanels')?.querySelector('input[type="radio"]');
    if (!target || !radio) return;
    radio.checked = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  window.addEventListener('hashchange', showRocklean);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showRocklean, { once: true });
  else showRocklean();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-storm-voices"] && !Shopify.designMode) return;
  try {
    class EbStormReviews extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.abort = new AbortController();
    this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.data = JSON.parse(this.querySelector('[data-reviews]').textContent);
    this.reviews = [...this.data.reviews].sort((a,b) => b.date.localeCompare(a.date) || a.id-b.id);
    this.limit = 12;
    this.list = this.dataset.mode === 'list';
    this.listen(this.querySelector('[data-star]'), 'change', () => this.filter());
    this.listen(this.querySelector('[data-more]'), 'click', () => { this.limit += 12; this.renderList(true); });
    this.listen(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
    this.listen(this.querySelector('[data-next]'), 'click', () => this.move(1));
    this.listen(this.querySelector('[data-track]'), 'keydown', event => {
      if (event.target !== event.currentTarget) return;
      if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home'?0:this.track.scrollWidth,behavior:this.behavior});
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    if (this.list) this.filter(); else this.renderCarousel();
  }
  disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  listen(node,type,callback) { node?.addEventListener(type,callback,{signal:this.abort.signal}); }
  get behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  text(tag,value,className) { const node=document.createElement(tag); node.textContent=value; if(className) node.className=className; return node; }
  link(label,url) { const a=this.text('a',label); a.href=url; return a; }
  card(review) {
    const card=document.createElement('article'); card.className='eb-voice-card'; card.id=`review-${review.id}`;
    const meta=this.text('div','','eb-voice-meta');
    const time=this.text('time',review.date.replaceAll('-','/')); time.dateTime=review.date;
    meta.append(this.text('span',this.labels.buyer),time);
    const stars=this.text('p','★'.repeat(review.rating)+'☆'.repeat(5-review.rating),'eb-voice-stars'); stars.setAttribute('aria-label',`${review.rating}/5`);
    card.append(meta,stars);
    if(review.title) card.append(this.text('h3',review.title));
    card.append(this.text('p',review.body,'eb-voice-body'));
    if(!this.list) {
      const foot=this.text('div','','eb-voice-foot');
      foot.append(this.link(this.labels.full,`${this.dataset.listUrl}#review-${review.id}`));
      card.append(foot);
    }
    return card;
  }
  filter() {
    this.limit=12;
    const star=this.querySelector('[data-star]').value;
    this.filtered=this.reviews.filter(r=>(!star||r.rating===Number(star)));
    this.renderList();
  }
  renderList(focusNew=false) {
    const grid=this.querySelector('[data-grid]'), previous=grid.children.length;
    const hash=location.hash.match(/^#review-(\d+)$/);
    let target;
    if(!focusNew&&hash) {
      target=this.filtered.findIndex(r=>r.id===Number(hash[1]));
      if(target>=0) this.limit=Math.max(this.limit, Math.ceil((target+1)/12)*12);
    }
    grid.replaceChildren(...this.filtered.slice(0,this.limit).map(r=>this.card(r)));
    this.querySelector('[data-count]').textContent=`${this.labels.published} ${this.reviews.length}${this.labels.unit} / ${this.labels.matching} ${this.filtered.length}${this.labels.unit}`;
    this.querySelector('[data-empty]').hidden=this.filtered.length>0;
    this.querySelector('[data-more]').hidden=this.limit>=this.filtered.length;
    if(focusNew&&grid.children[previous]) { grid.children[previous].tabIndex=-1; grid.children[previous].focus(); }
    if(target>=0) requestAnimationFrame(()=>grid.children[target]?.scrollIntoView({block:'start'}));
  }
  renderCarousel() {
    const selected=[...this.querySelectorAll('[data-review-id]')].map(node=>Number(node.dataset.reviewId));
    const unique=[...new Set(selected)].slice(0,Number(this.dataset.count)||6);
    const reviews=unique.map(id=>this.reviews.find(r=>r.id===id)).filter(Boolean);
    this.track=this.querySelector('[data-track]'); this.track.replaceChildren(...reviews.map(r=>this.card(r)));
    const update=()=>{
      this.querySelector('[data-prev]').disabled=this.track.scrollLeft<2;
      this.querySelector('[data-next]').disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
    };
    this.listen(this.track,'scroll',update); this.listen(window,'resize',update); requestAnimationFrame(update);
    this.querySelector('[data-status]').textContent=`${reviews.length}${this.labels.unit}`;
  }
  move(direction) { if(!this.track?.firstElementChild)return; this.track.scrollBy({left:direction*(this.track.firstElementChild.getBoundingClientRect().width+24),behavior:this.behavior}); }
}
if(!customElements.get('eb-storm-reviews'))customElements.define('eb-storm-reviews',EbStormReviews);
  } catch(e) { console.error(e); }
})();

})();
